import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Button, FormText, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {AvField, AvForm, AvGroup, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {IRootState} from 'app/shared/reducers';
import {getEntities as getRejectionReasons} from 'app/entities/rejection-reason-hf/rejection-reason.reducer';
import {createEntity as createPatientCaseRRHF} from 'app/entities/rejection-reason-hf/patient-case-rr-hf.reducer';
import {IPatientCaseRejectionReasonHF} from 'app/shared/model/patient-case-rr-hf.model';

export interface IRRHFModalProps extends StateProps, DispatchProps {
  isOpen: boolean;
  toggle: () => void;
  patientCaseId: string;
  hfId: string;
  onSuccess?: () => void;
}

export const RRHFModal = (props: IRRHFModalProps) => {
  let formRef: any;

  useEffect(() => {
    if (props.isOpen) {
      props.getRejectionReasons();
    }
  }, [props.isOpen]);

  useEffect(() => {
    if (props.updateSuccess) {
      props.toggle();
      if (props.onSuccess) {
        props.onSuccess();
      }
    }
  }, [props.updateSuccess]);

  const handleSubmit = (event, errors, values) => {
    if (errors && errors.length > 0) {
      return;
    }

    const selectedReasonId = values.selectedReason;
    if (!selectedReasonId) {
      return;
    }

    // Create a rejection reason record for the selected reason
    const rejectionRecord: IPatientCaseRejectionReasonHF = {
      patientCaseId: props.patientCaseId,
      hfId: props.hfId,
      rrHfId: selectedReasonId,
      description: values.description?.trim() || undefined
    };
    props.createPatientCaseRRHF(rejectionRecord);
  };

  const handleCancel = () => {
    if (formRef) {
      formRef.reset();
    }
    props.toggle();
  };

  const handleFormSubmit = () => {
    if (formRef) {
      formRef.submit();
    }
  };

  const activeReasons = props.rejectionReasons.filter(reason => reason.isActive);

  return (
    <Modal isOpen={props.isOpen} toggle={handleCancel} size="lg" backdrop="static">
      <ModalHeader toggle={handleCancel}>
        Unable to Accept Patient - Select Rejection Reason
      </ModalHeader>
      <ModalBody>
        <AvForm onSubmit={handleSubmit} ref={(ref) => formRef = ref}>
          <AvGroup>
            <label>Select rejection reason:</label>
            <div style={{
              maxHeight: '300px',
              overflowY: 'auto',
              border: '1px solid #ddd',
              padding: '10px',
              borderRadius: '4px'
            }}>
              {props.loading ? (
                <div>Loading rejection reasons...</div>
              ) : (
                <AvRadioGroup name="selectedReason" required>
                  {activeReasons.map(reason => (
                    <AvRadio
                      key={reason.id}
                      label={reason.enRejectionReason}
                      value={reason.id}
                      className="mb-2"
                    />
                  ))}
                </AvRadioGroup>
              )}
            </div>
          </AvGroup>

          <AvGroup>
            <AvField
              name="description"
              label="Additional Comments (Optional):"
              type="textarea"
              placeholder="Enter any additional comments..."
              rows="3"
              maxLength="500"
            />
            <FormText color="muted">
              Max 500 characters
            </FormText>
          </AvGroup>
        </AvForm>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancel} disabled={props.updating}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleFormSubmit}
          disabled={props.updating}
        >
          {props.updating ? 'Adding...' : 'Add Rejection'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state: IRootState) => ({
  rejectionReasons: state.rejectionReasonHF.entities,
  loading: state.rejectionReasonHF.loading,
  updating: state.patientCaseRRHF.updating,
  updateSuccess: state.patientCaseRRHF.updateSuccess,
});

const mapDispatchToProps = {
  getRejectionReasons,
  createPatientCaseRRHF,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RRHFModal);
